<div class="bg-primary h-100vh">
    <grid-row class="justify-content-center align-content-center h-100">
        <grid-col col="5" class="text-align-center">
            <div class="text-align-center">
                <i class="icon-error-big"></i>
            </div>
            <div class="font-500 font-size-32px color-base-100 mt-25">
                {{ "Failed" | translate }}
            </div>
        </grid-col>
    </grid-row>
</div>